import validationConfig from '../../../validation-config.json';
import { SharedDialog } from '../../../common/SharedDialog';

interface DeleteQuestionDialogProps {
  questionTitle: string;
  isOpen: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DELETE_DIALOG_MESSAGES = {
  title: (validationConfig as Record<string, unknown>)['ADMIN_QUESTIONS_PAGE']?.['_deleteDialog']?.['title'] ?? 'Delete question ?',
  description: (validationConfig as Record<string, unknown>)['ADMIN_QUESTIONS_PAGE']?.['_deleteDialog']?.['description'] ?? '"{questionTitle}" will be soft-deleted and removed from all survey assignments. This action can be reversed by an administrator.',
};

export const DeleteQuestionDialog = ({
  questionTitle,
  isOpen,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteQuestionDialogProps) => {
  const descriptionText = DELETE_DIALOG_MESSAGES.description.replace('{questionTitle}', questionTitle);

  return (
    <SharedDialog
      mode="confirm"
      ariaLabel="Delete question"
      isOpen={isOpen}
      onClose={onCancel}
      title={DELETE_DIALOG_MESSAGES.title}
      description={descriptionText}
      secondaryAction={{ label: 'Cancel', variant: 'outline', disabled: isDeleting, onClick: onCancel }}
      primaryAction={{
        label: isDeleting ? 'Deleting…' : 'Delete',
        intent: 'danger',
        disabled: isDeleting,
        onClick: onConfirm,
        ariaLoadingLabel: 'Deleting question',
      }}
    />
  );
};
